import React, { Component } from 'react';
import _ from 'lodash';
import CompetitorsTypeSelects from '../../CompetitorsGroupsType/CompetitorsTypeSelects/CompetitorsTypeSelects';
import CompetitorsIndirectSelects from '../../CompetitorsGroupsIndirect/CompetitorsIndirectSelects/CompetitorsInderectSelects';

class CompetitorsGroupsList extends Component {
    constructor(props) {
        super(props);
        this.defaultParams = {};
        this.state = {

        };
    }
    deleteItem = (data) => {
        this.props.deleteModalOpen(data.competitorId);
    }

    render() {
        let groupsList = _.map(this.props.competitorsGroupsData.Items[0].competitors, (value, index) => {
            return (
                <li key={index}>
                    <p><strong>{value.competitorName}</strong></p>
                    {this.props.groupStepState === 3 && <p>{value.indirect}</p> }
                    {this.props.groupStepState === 1 &&
                        <i onClick={() => this.deleteItem(value)} className="fas fa-trash-alt"></i>
                    }
                    {this.props.groupStepState === 3 &&
                        <CompetitorsTypeSelects
                            data={value}
                            changeCompetitorsGroupsType={this.props.changeCompetitorsGroupsType}
                        />
                    }
                    {this.props.groupStepState === 2 &&
                        <CompetitorsIndirectSelects
                            data={value}
                            changeCompetitorsGroupsIndirect={this.props.changeCompetitorsGroupsIndirect}
                        />
                    }
                </li>
            )
        });

        return (
            <div className='row'>
                <div className='col-sm-12'>
                    <div className='customer-groups-list-content'>
                        <ul>
                            {groupsList}
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}

export default (CompetitorsGroupsList);



// WEBPACK FOOTER //
// ./src/components/CompetitiveAnalysis/CompetitorsGroups/CompetitorsGroupsList/CompetitorsGroupsList.jsx